module.exports = __webpack_public_path__ + "static/media/pic4.af1e9499.jpg";